import script from "./Label.vue?vue&type=script&setup=true&lang=js"
export * from "./Label.vue?vue&type=script&setup=true&lang=js"

import "./Label.vue?vue&type=style&index=0&id=1e02026c&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e02026c"]])

export default __exports__